class TableStickyScrollbar extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-table-scroll]');
    this.bar = this.querySelector('[data-table-scrollbar]');
    this.track = this.querySelector('[data-scrollbar-track]');
    this.thumb = this.querySelector('[data-scrollbar-thumb]');
    if (!this.scroller || !this.bar) return;

    this.inView = false;
    this.update = this.update.bind(this);

    this.scroller.addEventListener('scroll', () => this.positionThumb(), { passive: true });
    window.addEventListener('resize', this.update);

    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.scroller);

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        this.inView = entries[0].isIntersecting;
        this.toggle();
      },
      { threshold: 0 }
    );
    this.intersectionObserver.observe(this.scroller);

    this.initDrag();
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.update);
    this.resizeObserver?.disconnect();
    this.intersectionObserver?.disconnect();
  }

  update() {
    const rect = this.scroller.getBoundingClientRect();
    this.bar.style.left = `${rect.left}px`;
    this.bar.style.width = `${rect.width}px`;
    this.hasOverflow = this.scroller.scrollWidth > this.scroller.clientWidth + 1;
    this.positionThumb();
    this.toggle();
  }

  toggle() {
    this.bar.classList.toggle('is-visible', Boolean(this.inView && this.hasOverflow));
  }

  positionThumb() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
    const trackWidth = this.track.clientWidth;
    const maxScroll = scrollWidth - clientWidth;
    if (maxScroll <= 0 || trackWidth <= 0) return;

    const thumbWidth = Math.max(32, trackWidth * (clientWidth / scrollWidth));
    const maxLeft = trackWidth - thumbWidth;
    this.thumb.style.width = `${thumbWidth}px`;
    this.thumb.style.transform = `translateX(${(scrollLeft / maxScroll) * maxLeft}px)`;
  }

  initDrag() {
    let startX = 0;
    let startScroll = 0;
    let dragging = false;

    this.thumb.addEventListener('pointerdown', (event) => {
      dragging = true;
      startX = event.clientX;
      startScroll = this.scroller.scrollLeft;
      this.thumb.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    this.thumb.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const maxLeft = this.track.clientWidth - this.thumb.offsetWidth;
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      if (maxLeft <= 0) return;
      this.scroller.scrollLeft = startScroll + ((event.clientX - startX) / maxLeft) * maxScroll;
    });

    ['pointerup', 'pointercancel'].forEach((type) => {
      this.thumb.addEventListener(type, () => {
        dragging = false;
      });
    });
  }
}

customElements.define('table-sticky-scrollbar', TableStickyScrollbar);